import Header from "./components/Header";
import Hero from "./components/Hero";
import QuickArchive from "./components/QuickArchive";
import WeeklyFeed from "./components/WeeklyFeed";
import Recap from "./components/Recap";
import Monthly from "./components/Monthly";
import Sectors from "./components/Sectors";
import HotRank from "./components/HotRank";
import Timeline from "./components/Timeline";
import CtaBand from "./components/CtaBand";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="bg-background-50 text-foreground-900">
      <Header />
      <Hero />
      <QuickArchive />
      <WeeklyFeed />
      <Recap />
      <Monthly />
      <Sectors />
      <HotRank />
      <Timeline />
      <CtaBand />
      <Footer />
    </div>
  );
}